<template>
  <nav class="nav">
    <div class="container is-fluid">
      <!-- Left -->
      <div class="nav-left" v-if="$slots.left">
        <slot name="left"></slot>
      </div>

      <!-- Center -->
      <div class="nav-center" v-if="$slots.center">
        <slot name="center"></slot>
      </div>

      <!-- Hamburger menu -->
      <span class="nav-toggle" :class="{ 'is-active': isActive }" @click="isActive = !isActive" v-if="$slots.right">
        <span></span>
        <span></span>
        <span></span>
      </span>

      <!-- Right -->
      <div class="nav-right nav-menu" :class="{ 'is-active': isActive }" v-if="$slots.right">
        <slot name="right"></slot>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isActive: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  nav {
    background-color: #1F2224;
  }

  strong {
    color: white;
    font-weight: 300;
  }

  .nav {
    @include mobile() {
      height: auto;
    }
  }

  .nav-left {
    overflow: visible;

    @include mobile() {
      flex-direction: column;
    }
  }

  .nav-item {
    @include mobile() {
      padding: 0;
      padding-top: 0.3rem;
    }
  }

  .nav-menu {
    background-color: #1F2224;
  }

</style>



// WEBPACK FOOTER //
// NavBar.vue?1b37ee85